// Carry Roll QuickSettings — compact panel rendered inside the calc-nav SettingsDrawer.
// Surfaces the most-used preferences (units + fidelity) for fast access without
// navigating to the full Settings screen.

import { UnitsSwitch } from '../settings/UnitsSwitch';
import { FidelitySelector } from '../settings/FidelitySelector';
import { OfflineStatus } from '../settings/OfflineStatus';
import { ThemeSelector } from '../settings/ThemeSelector';
import { goNav } from '../../lib/nav';

export function QuickSettings() {
  return (
    <div data-testid="quick-settings" className="flex flex-col gap-4">
      <ThemeSelector />
      <UnitsSwitch />
      <FidelitySelector />
      <OfflineStatus />
      <button
        type="button"
        onClick={() => goNav('settings')}
        className="btn"
        style={{ justifyContent: 'center', marginTop: 'var(--space-2)' }}
      >
        All settings
      </button>
    </div>
  );
}
